export default __webpack_public_path__ + "static/media/Boots of Clarity.cd19068e.jpg";